import { render, staticRenderFns } from "./FlashBloc.vue?vue&type=template&id=245a0922"
import script from "./FlashBloc.vue?vue&type=script&lang=js"
export * from "./FlashBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports